/**
 * SelfWorth Theme — Luxury Vault
 * Dark obsidian with warm gold/amber accents
 */

// DM Sans for body — refined humanist sans. Cormorant Garamond for display headers — editorial luxury.
const font = {
  url: 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;0,700;1,400;1,600&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap',
  family: "'DM Sans', sans-serif",
};

export const theme = {
  colors: {
    background: '30 8% 4%',
    foreground: '40 15% 92%',
    card: '30 6% 7%',
    'card-foreground': '40 15% 92%',
    popover: '30 6% 7%',
    'popover-foreground': '40 15% 92%',
    primary: '38 65% 57%',
    'primary-foreground': '30 8% 4%',
    secondary: '30 5% 12%',
    'secondary-foreground': '40 15% 75%',
    muted: '30 5% 10%',
    'muted-foreground': '35 8% 52%',
    accent: '43 75% 68%',
    'accent-foreground': '30 8% 4%',
    destructive: '0 65% 48%',
    'destructive-foreground': '0 0% 100%',
    border: '35 12% 14%',
    input: '35 12% 14%',
    ring: '38 65% 57%',
    link: '38 65% 65%',
    'link-hover': '43 75% 72%',
    button: '30 5% 12%',
    'button-foreground': '40 15% 88%',
    'button-border': '35 12% 18%',
    'button-hover': '30 5% 16%',
    'button-hover-foreground': '40 15% 96%',
    'button-hover-border': '38 45% 30%',
    'button-ring': '38 65% 57%',
    'chart-1': '38 65% 57%',
    'chart-2': '43 75% 68%',
    'chart-3': '28 55% 48%',
    'chart-4': '50 80% 72%',
    'chart-5': '15 60% 52%',
    'sidebar-background': '30 8% 3%',
    'sidebar-foreground': '40 15% 80%',
    'sidebar-primary': '38 65% 57%',
    'sidebar-primary-foreground': '30 8% 4%',
    'sidebar-accent': '30 5% 10%',
    'sidebar-accent-foreground': '40 15% 75%',
    'sidebar-border': '35 12% 12%',
    'sidebar-ring': '38 65% 57%',
  },
  font,
  radius: '0.375rem',
};
